module.exports = __webpack_public_path__ + "media/Night-Traffic.0974c7d5.mp4";